import * as React from "react"
import type { SVGProps } from "react"
const SvgCheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.6 13.4-2.15-2.15a1 1 0 0 0-.7-.28 1 1 0 0 0-.7.28 1 1 0 0 0-.28.7q0 .43.28.7L9.9 15.5q.3.3.7.3t.7-.3l5.65-5.65a1 1 0 0 0 .28-.7 1 1 0 0 0-.28-.7 1 1 0 0 0-.7-.27 1 1 0 0 0-.7.27zM5 21q-.82 0-1.41-.59A2 2 0 0 1 3 19V5q0-.82.59-1.41A2 2 0 0 1 5 3h14q.83 0 1.41.59.6.59.59 1.41v14q0 .83-.59 1.41A2 2 0 0 1 19 21zm0-2h14V5H5z" />
  </svg>
)
export default SvgCheckSquare
